import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Iconify, Page } from "src/components";
import { useAppContext } from "src/hooks";
import { _subscription_listing } from "src/DAL/subscription";
import { useSnackbar } from "notistack";
import CancelSubscriptionConfrimation from "src/components/CancelSubscriptionConfirmation/CancelSubscriptionConfrimation";
import { _cancel_subscription } from "src/DAL";
import { _get_active_plans } from "src/DAL/plans";
import { result } from "lodash";
import moment from "moment";
import PricingPlansCard from "./PricingPlansCard";
import { capitalCase } from "change-case";

function Plans() {
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  const { dispatch_get_user_profile, dispatch_set_user_profile } =
    useAppContext();
  const user = dispatch_get_user_profile();
  const userInfo = user;
  console.log(userInfo, "userrrrrrrrrrrrrr");
  const { enqueueSnackbar } = useSnackbar();
  const [userSubscription, setUserSubscription] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [openDelete, setOpenDelete] = useState(false);
  const [activePlans, setActivePlans] = useState([]);
  console.log(activePlans, "plannnnss");

  const getActivePlans = async () => {
    setIsLoading(true);
    const result = await _get_active_plans();
    if (result.code === 200) {
      setActivePlans(result?.subscription_plan);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      enqueueSnackbar("Something went wrong!", { variant: "error" });
      console.log(error, " catched while fetching user active plans");
    }
  };

  const getUserSubscription = async () => {
    try {
      if (!user?.user_id) return;
      const result = await _subscription_listing(user.user_id);
      if (result.code === 200) {
        console.log(result.subscription, "subscription detail");
        setUserSubscription(result?.subscription);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
      console.error("Error fetching user subscriptions:", error);
    }
  };

  const handleCancelSubscription = () => {
    setOpenDelete(true);
  };

  const handleAgreeCancel = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const postData = {
      subscription_id: userSubscription?._id,
    };
    const result = await _cancel_subscription(postData);
    if (result.code === 200) {
      setIsLoading(false);
      dispatch_set_user_profile({ ...user, subscription_plan_id: null });
      enqueueSnackbar(result.message, {
        variant: "success",
      });
      setUserSubscription({});
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log(user?.user_id, "iddddddddddddddddd");
    if (user?.user_id) {
      getUserSubscription();
    }

    getActivePlans();
  }, [user]);

  if (isLoading) {
    return (
      <div
        style={{ minHeight: "100vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <Page className="payment-plans" title="Payment Plans">
      <Container maxWidth={false}>
        <div className="row">
          <div className="col-12">
            {/* ============================ Cancel subscription ============================ */}
            {userSubscription && (
              <div className="row">
                <div className="mb-3 pb-4 px-4 col-12 ">
                  <Paper
                    elevation={1}
                    sx={{
                      borderRadius: "8px",
                      padding: "15px",
                    }}
                    className="d-flex justify-content-between"
                  >
                    <div className="d-flex gap-2 mb-1">
                      <Iconify
                        icon="mdi:check-circle"
                        style={{
                          color: "#00AB55",
                          fontSize: 20,
                        }}
                      />

                      <Typography fontSize={14}>
                        <>
                          Active Plan:{" "}
                          <Typography
                            fontSize={14}
                            component="span"
                            sx={{ fontWeight: 500 }}
                          >
                            {capitalCase(
                              user?.subscription_plan_id?.name || ""
                            )}
                          </Typography>
                        </>
                      </Typography>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div style={{ textAlign: "right" }}>
                        <div className="d-flex justify-content-end align-items-center gap-2 ">
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: 12,
                            }}
                          >
                            Subscription Date:
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {moment(userSubscription?.subscription_date).format(
                              "LL"
                            )}
                          </Typography>
                        </div>

                        <div className="d-flex justify-content-end align-items-center gap-2 ">
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: 12,
                            }}
                          >
                            Renewal Date:
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {moment(
                              userSubscription?.subscription_renewal_date
                            ).format("LL")}
                          </Typography>
                        </div>

                        <div className="mt-1">
                          <Button
                            variant="text"
                            color="error"
                            sx={{ fontWeight: "600" }}
                            onClick={handleCancelSubscription}
                          >
                            Cancel Subscription
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Paper>
                </div>
              </div>
            )}
            {/* ============================================================================= */}
            <div className="plan-header m-3 pb-2 text-center ">
              <Typography
                sx={{ fontSize: is_mobile_view ? "24px" : "2.25rem" }}
                color={"primary.main"}
                fontWeight={600}
              >
                Ready to get started?
              </Typography>
              <Typography
                variant={is_mobile_view ? "h6" : "h4"}
                mt={0.5}
                fontWeight={600}
              >
                Plans and pricing
              </Typography>
              <Typography fontSize={"14px"} mt={1}>
                Pick a plan that fits the way your team works and grows.
              </Typography>
            </div>
          </div>
        </div>

        <PricingPlansCard
          handleCancelSubscription={handleCancelSubscription}
          activePlans={activePlans}
        />
      </Container>

      <CancelSubscriptionConfrimation
        open={openDelete}
        setOpen={setOpenDelete}
        handleAgree={handleAgreeCancel}
      />
    </Page>
  );
}

export default Plans;
